module.exports = __webpack_public_path__ + "static/media/remove.cc273d40.svg";